<section class="page-title" style="background-image: url(assets/images/breadcom.png);">
  <div class="auto-container">
    <div class="content-box">
      <div class="row">
        <div class="col-6">
          <div class="title">
            <h1>Forgot Password </h1>
          </div>
        </div>
        <div class="col-6">


          <ul class="bread-crumb clearfix text-right">
            <li><a routerLink="/">Home</a></li>
            <li>Forgot Password </li>
          </ul>
        </div>

      </div>

    </div>
  </div>
</section>


<div id="main-wrapper" class="oxyy-login-register">
  <div class="container-fluid">
    <div class="row g-0 min-vh-100">
      <!-- Welcome Text
          ========================= -->
      <div class="col-md-6">
        <div class="hero-wrap d-flex align-items-center h-100">
          <div class="hero-mask opacity-8 bg-primary"></div>

          <div class="hero-content w-100 min-vh-100 d-flex flex-column">

            <div class="row g-0 my-auto">
              <div class="col-10 col-lg-9 mx-auto">
                <h1 class="text-11  mb-4"><span>ANMW</span> National Distribution Monitor</h1>
                <p class="text-4  lh-base mb-5">Welcome to the ANMW National Distribution Monitor which provides
                  constantly updated
                  information on national newspaper distribution throughout the UK</p>

                <img src="./assets/images/loginimg.png">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Welcome Text End -->

      <div class="col-md-6 d-flex login_pag">
        <div class="container">
          <div class="row g-0">
            <div class="col-10 col-lg-10 col-xl-9 mx-auto">
              <!-- Forgot Password  Form
          ========================= -->
              <div class="main_login forgot_pag">
                <h3 class="fw-600 ">Forgot Password </h3>
                <p class="mb-4">Enter your credential to get access</p>
                <form id="loginForm" [formGroup]="form" (ngSubmit)="submitPage()">
                  <div class="mb-2">
                    <label for="emailAddress" class="form-label">Email Address</label>
                    <input type="email" formControlName="email" class="form-control" id="emailAddress" required
                      placeholder="Enter Your Email">

                    <div
                      *ngIf="this.form.get('email')?.errors?.['required']  && (form.controls['email'].dirty|| form.controls['email'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      Email is required.
                    </div>

                    <div
                      *ngIf="this.form.get('email')?.errors?.['pattern']  && (form.controls['email'].dirty|| form.controls['email'].touched)"
                      class="col-sm-12 input-fields-wrapper text-red error-message">
                      <i class="icon-help-circled"></i>
                      Email is not valid.
                    </div>
                  </div>

                  <div class="row">

                    <div class="col-12">

                      <div class="d-grid text-right">
                        <button type="button" (click)="reset()" class="theme-btn style-one">Reset</button>
                        <button type="submit" class="theme-btn style-two">Send</button>
                      </div>
                    </div>

                    <div *ngIf="requested" class="col-12 mt-3" style="color:green">
                      Reset password link has been sent to email, Please verify.
                    </div>
                  </div>

                </form>
              </div>
              <!-- Forgot Password  Form End -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>